import Modal from "react-modal";
import SelectList from "../../../../components/SelectList";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BiSearch } from "react-icons/bi";
import "./style.css";
import useAppAccessor from "../../../../hooks/useappAccessor";
import {
  multiSelectMedia,
  setMediaSelectedData,
} from "./interactionMedia.action";
import { isEmpty } from "lodash";
import { setInteractionData } from "../../interaction.actions";
import { InteractionData } from "../../interaction.interface";
import { TfiClose } from "react-icons/tfi";
import { saveInteractionAPI } from "../../../../services/record.service";
import NoResult from "../../../../components/NoResult";
import { toast } from 'react-toastify';
import { callEvent } from "../../../../services/main.service";
import { getBrandColor } from "../../../../utils/brand.util";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "85%",
    width: "80%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: 0,
    backgroundColor: "#000000",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.8)",
    zIndex: 99999,
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)

function InteractionMedia(props: any) {
  let subtitle: any;
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { getLiveMainData, getInteractions, getUserData } = useAppAccessor();
  const { interactionData } = getInteractions();
  const { repsiteData,configurationData } = getLiveMainData();
  const { joinWithAttendeeData,createStreamData, hostTime } = getLiveMainData();
  const { core_configuration } = repsiteData;
  const { media_configuration } = core_configuration;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectList, setSelectList] = useState("total");
  const [mediaFilter, setMediaFilter] = useState([]);
  const { getMediaSelectedData } = useAppAccessor();
  const { dataMediaSelected } = getMediaSelectedData();
  const {client} = getUserData();
  const [dataMediaInteraction, setdataMediaInteraction] = useState([]);
  const [interactionDataArray, setInteractionDataArray] = useState<
    InteractionData[]
  >([]);

  const [selectedItems, setSelectedItems] = useState<any>([]);
  const { language } = getUserData();

  const dispatch = useDispatch();

  //   function openModal() {
  //     setIsOpen(true);
  //   }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    // setIsOpen(false);
    props.handleCloseMediaInteraction(false);
  }


  function searchItems(items: any, searchTerm: any) {
    return items.filter((item: any) => {
      return item.title.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }

  function filterItems(items: any, mediaType: any) {
    return items.filter((item: any) => {
      if (mediaType === "total") {
        return items;
      } else {
        return item.type.includes(mediaType);
      }
    });
  }

  const handleMediaSelectedData = (items: any) => {
   // console.log("media Item===>", items);
    const isSelected = selectedItems.includes(items);

    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((selectedItem:any) => selectedItem !== items)
      );
    } else {
      if(!checkElementPresentInArray(items?.asset_id)){
      setSelectedItems([...selectedItems, items]);
      }else{
        toast(`${items.title} ${language['already_in_interactions']}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
      }
    }
    //addInteractionDataToArray(item);
    // const newDataArray = [...dataMediaInteraction, item];
    // dispatch(multiSelectMedia(newDataArray));
    // dispatch(setMediaSelectedData(item));
    // closeModal();
  };

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionDataArray(interactionData);
    }
  }, []);

  useEffect(() => {
    setMediaFilter(filterItems(media_configuration?.media, selectList));
  }, [selectList]);

  useEffect(() => {
    setMediaFilter(searchItems(media_configuration?.media, searchTerm));
  }, [searchTerm]);

  useEffect(() => {
    if (!media_configuration) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [props.modalIsOpen]);

  const addInteractionDataToArray = (item: any) => {
    selectedItems.forEach((item:any) => {
      var resp = createStreamData;
      if (resp && resp['metadata'] && resp['metadata']['attendees'] && resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')) {
      var hostInfo = resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')[0];
      callEvent([{"event_data":{
        "attendee_email":hostInfo["email"],
        "attendee_first":hostInfo["given_name"],
        "attendee_id":hostInfo["attendee_id"],
        "attendee_role":"attendee",
        "attendee_last":hostInfo["family_name"]+ " (host)",
        "client_id":hostInfo.attendee_id.split('|')[0],
        "stream_id":joinWithAttendeeData['stream_id'],
        "stream_instance_id":resp["stream_instance_id"],
        "user_id":hostInfo.attendee_id.split('|')[1],
        "interaction_id": item?.id,
        "interaction_type": "media",
        "interaction_label": item?.name,
        "interaction_action": item?.shopUrl,
        "interaction_imageUrl": item?.imageUrl,
        "elapsed_seconds":hostTime,
        "date":new Date().toUTCString()},
        "event_type":"interaction_created"}]);
      }
      setInteractionDataArray((prevArray) => [
        ...prevArray,
        {
          attributes: {
            action: item?.url,
            label: item?.title,
            price: "",
            description: item?.description,
            isLinkedToStore: false,
            shouldShow: true,
            labelVisible: true,
            thirdPartyUsername: "",
            assetId: item?.asset_id,
          },
          style: {
            style_type: "photo",
            pulse_animation: false,
            opacity: 1,
            thumbnail_url: item?.thumbnail_url,
          },
          center_x: 50,
          center_y: 50,
          rotation_angle: 0,
          start: 0,
          end: 5,
          height_max: 100,
          height_pc: 17,
          width_max: 100,
          width_pc: 8,
          featured: false,
          interaction_id: item?.asset_id,
          interaction_type: "media",
          interaction_subtype: "other",
        },
      ]);
    });

    setSelectedItems([]);

    setTimeout(() => {
      props.handleCloseMediaInteraction(true);
    }, 200);
  };

  useEffect(() => {
    dispatch(setInteractionData(interactionDataArray));
    saveInteractionAPI(configurationData?.stream_id,interactionDataArray);
      //  interactionDataArray.filter((data:any) => data.attributes.shouldShow === true));

  }, [interactionDataArray]);

  const checkElementPresentInArray=(id:any)=>{
   // console.log("Interactionnn=>In Checl",interactionDataArray)
    return interactionDataArray.some((element:any) => element.interaction_id === id)
  }

  const checkTitle = (title : string) => {

    const formattedStringFirst = title.replace(/#\d+\b\.?\s?/g, '');
    const formattedString = formattedStringFirst.replace(/[^\x20-\x7E®]/g, '');
    
    if(formattedString.includes('Lumire')) {
        return formattedString.replace('Lumire', "Lumière")
    }

      return formattedString.trim(); 
  } 


  return (
    <>
      {!loading ? (
        <Modal
          isOpen={props.modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="flex w-full h-full bg-neutral-800 " id={"ModalInner"}>
            <div className="flex flex-col w-full bg-black  rounded-lg p-4">
              <div className="flex w-full justify-between">
                <span className="text-white text-2xl font-medium">
                  {language["my_media"]}
                </span>
                <TfiClose
                  color="#DEDEDE"
                  size={20}
                  cursor="pointer"
                  className="mr-2"
                  onClick={() => {
                    closeModal();
                  }}
                />
              </div>
              <div className="w-full bg-white h-0.5 my-2" />
              <div>
                <span className="text-white">
                  {language["select_media_assets"]}
                </span>
              </div>
              <div className="flex flex-row my-4" style={{zIndex:1}}>
                <SelectList
                  defaultSelectedItem={{ key: "total", value: language['all_button'] }}
                  data={[
                    ...media_configuration?.media_types,
                    { key: "total", value: language['all_button'] },
                  ]}
                  onSelect={(item: any) => {
                    setSelectList(item.key);
                  }}
                />

                <div className="flex flex-row border-2 border-zinc-700 rounded-lg ml-6 items-center justify-center px-4">
                  <BiSearch fill="white" size="24" />
                  <input
                    className="bg-black text-white pl-2 outline-none placeholder:text-white"
                    placeholder={language['search_label']}
                    onChange={(event) => setSearchTerm(event.target.value)}
                  />
                </div>
              </div>
              {/* overflow-y-scroll no-scrollbar */}
              <div className="h-full w-full overflow-y-scroll containerModal">
                {
                  mediaFilter.length == 0 ? loading ? (
                    <div className="flex justify-center items-center h-full">
                      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white"></div>
                    </div>
                  ) : (
                    <NoResult></NoResult>
                  ) :
                  <div className="grid grid-cols-6 gap-2 ">
                  {mediaFilter.map((item: any) => {
                    const isSelected = selectedItems.includes(item);

                    return (
                      <div
                        className={`flex flex-col p-2 ${
                          isSelected ? "selected-item" : ""
                        }`}
                        key={item?.asset_id}
                        onClick={() => {
                          handleMediaSelectedData(item);
                        }}
                      >
                        <div className="rounded-lg inset-0 w-full h-44 bg-zinc-300">
                          {isSelected && <div className="selected-indicator"  
                          style={{backgroundColor: `${getBrandColor(client)} `}}/>}

                          <img
                            className="h-full w-full object-cover object-center rounded-lg "
                            src={`${item.thumbnail_url}`}
                            onError={(event) => {
                              event.currentTarget.src =
                                "https://andersnoren.se/themes/koji/wp-content/themes/koji/assets/images/default-fallback-image.png";
                            }}
                            alt=""
                          />
                        </div>
                        <div className="text-white mt-2 line-clamp-2 font-semibold">
                          {/* {checkTitle(item.title)} */}
                          <div dangerouslySetInnerHTML={{ __html: checkTitle(item.title) }} />
                        </div>
                        {/* <div className="text-white mt-2 line-clamp-2 font-light	">
                          {item.description}
                        </div> */}
                      </div>
                    );
                  })}
                </div>
                }
                
                {selectedItems.length > 0 && (
                  <div
                  className={`h-12 w-64 flex items-center justify-center rounded-lg ml-[40%] cursor-pointer fixed bottom-4`}
                    onClick={() => {
                      addInteractionDataToArray(selectedItems);
                      // selectedItems.forEach((item:any) => {
                      //   var resp = createStreamData;
                      //   var data = item;
                      //   if (resp && resp['metadata'] && resp['metadata']['attendees'] && resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host'))
                      //   callEvent([{"event_data":{
                      //     "attendee_email":resp["email"],
                      //     "attendee_first":resp["given_name"],
                      //     "attendee_id":resp["attendee_id"],
                      //     "attendee_role":"attendee",
                      //     "attendee_last":resp["family_name"]+" (host)",
                      //     "client_id":resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')[0].attendee_id.split('|')[0],
                      //     "stream_id":joinWithAttendeeData['stream_id'],
                      //     "stream_instance_id":resp["stream_instance_id"],
                      //     "user_id":resp['metadata']['attendees'].filter((p: { role: string; }) => p.role == 'host')[0].attendee_id.split('|')[1],
                      //     "interaction_id": data.interaction_id,
                      //     "interaction_type": data.attributes.type,
                      //     "interaction_label": data.attributes.label,
                      //     "interaction_action": data.attributes.action,
                      //     "interaction_imageUrl": data.style.thumbnail_url,
                      //     "elapsed_seconds":hostTime,
                      //     "date":new Date().toUTCString()},
                      //     "event_type":"interaction_created"}]);
                      // });

                    }}
                    style={{backgroundColor: `${getBrandColor(client)} `}}
                    >
                    <span className="text-white text-2xl">{language['add_button']}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        <Modal
          isOpen={props.modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="flex w-full h-full bg-neutral-800 " id={"ModalInner"}>
            <div className="flex flex-col w-full bg-black  rounded-lg p-4">
              <span className="text-white text-2xl font-medium">
                {language["my_media"]}
              </span>
              <div className="w-full bg-white h-0.5 my-2" />
              {/* overflow-y-scroll no-scrollbar */}
              <div className="h-full w-full overflow-y-scroll containerModal">
                <div className="grid grid-cols-6 gap-2 ">
                  <h1>Loading...</h1>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default InteractionMedia;
